import { REQUEST_EDIT_PIPELINE_MODAL_YES_NO_OPTION_VALUE } from './RequestEditPipelineModal.constants'

export function isRequestEditPipelineModalYesNoOptionValueYes(value) {
  return value === REQUEST_EDIT_PIPELINE_MODAL_YES_NO_OPTION_VALUE.Yes
}

export function getRequestEditPipelineModalRadioOptions(t) {
  return [
    {
      id: REQUEST_EDIT_PIPELINE_MODAL_YES_NO_OPTION_VALUE.No,
      label: t('RequestProfile.EditPipelineModalNoOptionKey'),
    },
    {
      id: REQUEST_EDIT_PIPELINE_MODAL_YES_NO_OPTION_VALUE.Yes,
      label: t('RequestProfile.EditPipelineModalYesOptionKey'),
    },
  ]
}
